import { Component } from '@angular/core';
import { ModalService } from '../modal.service';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;

/**
 * This class represents the customized information modal component
 */
@Component({
    selector: 'custom-alert-modal',
    templateUrl: 'custom-alert-modal.component.html',
    standalone: false
})

export class CustomAlertModalComponent {

	translateSrc: string;
	params:any = { value: '' };
	private _okBtn: HTMLElement;

	constructor(modalService: ModalService) {	
	modalService.customAlert  = this.customAlert.bind(this);	
	}

	ngOnInit() {
		this._okBtn = document.getElementById('okBtn');		
	  }

	customAlert(msgKey: string, params?: any): Promise<boolean> {		
		this.translateSrc = msgKey;
		this.params = params;		
		const promise = new Promise<boolean>(resolve => {
			this._configureCustomAlertModal(resolve);
		  });
		  return promise;		  
	}

	private _configureCustomAlertModal(resolve: (x: boolean) => any) {	
		$('#confirmModal').modal('show');		
		const ok = (e:any) => resolve(true);
		const cancelled = (e:any) => resolve(false);			
		
		if (!this._okBtn) {return cancelled(null);}	
		this._okBtn.onclick = ((e:any) => {
		  e.preventDefault();
		  $('#customAlertModal').modal('hide');
		  ok(e);
		});

		$('#customAlertModal').modal('show');
	  }
}
